<template>
  <div class="acmper">

    <!-- 顶部按钮 -->
    <div>
      <button class="buttons" style="background-color: #ee0a24;" @click="back()">返回小队</button>
    </div>
    <!-- /顶部按钮 -->


    <div v-if="loading" class="gundong" style="margin-top: 20px;">
      <div style="width: 200%;">
        <van-row>
          <van-col span="3" class="text-center">姓名</van-col>
          <van-col span="1" class="text-center">性别</van-col>
          <van-col span="2" class="text-center">护照</van-col>
          <van-col span="2" class="text-center">印章</van-col>
          <van-col span="16" class="text-left">徽章</van-col>

        </van-row>

        <div style="margin-top:5px">
          <div v-for="(item2, index2) in List" :key="index2">
            <van-row type="flex" style="margin-top:5px">
              <van-col span="3" class="text-center line-h20">{{ item2.real_name }}</van-col>
              <van-col span="1" class="text-center">
                {{ item2.sex == 'man' ? '男' : '女' }}
              </van-col>
              <van-col span="2" class="text-center">
                <div>
                  <van-switch :value="item2.e_pst" @input="onInput($event, item2, 'e_pst')" size="16" />
                </div>
              </van-col>
              <van-col span="2" class="text-center">
                <div>
                  <van-switch :value="item2.e_pst_stamp" @input="onInput($event, item2, 'e_pst_stamp')" size="16" />
                </div>
              </van-col>
              <van-col span="2" class="text-left">

                <span v-for="(item3, index3) in item2.medal" :key="index3" class="huizhang"
                  :class="{ 'gold': item3.status == 1 }" @click="onBadge(item2, item3, index3)">
                  {{ item3.medal_title }}</span>
              </van-col>
            </van-row>
          </div>
        </div>
      </div>

    </div>
    <div v-else style="position:absolute;top: 50%; left: 50%;transform: translate(-50%,-50%);">
      <van-loading>加载中...</van-loading>

    </div>

  </div>
</template>
<script>
import { async } from 'q'
import util from '../../../common/util'
import { locations } from '../../../common/getLocation'
import { Toast } from 'vant'
export default {
  data () {
    return {
      List: [],
      job: '',
      team3_id: '',
      loading: false,
    }
  },
  created () {
    this.team3_id = this.$route.query.team3_id
    this.getListInfo()
    // this.getLongitudeLatitude()
  },
  methods: {
    async getListInfo () {
      this.loading = false
      const res = await this.$axios.get('/project/team3-sign-list', {
        params: {
          team3_id: this.team3_id,
        },
      })
      if (res.data.code == 200) {
        this.job = res.data.data.job
        let data = res.data.data.members
        for (let i = 0; i < data.length; i++) {
          data[i].e_pst = data[i].e_pst == 1 ? true : false
          data[i].e_pst_stamp = data[i].e_pst_stamp == 1 ? true : false
        }
        this.List = data
        this.loading = true
      }
      let config = {
        img: 'https://img.jiarixiaodui.com/jrhb-logo.jpg',
        sharePath: `/sign?team3_id=${this.team3_id}`,
      }
      this.wxShare(config)
    },
    onInput (checked, item, params) {
      if (this.job > 3) {
        this.$toast('无权操作')
        return
      }
      const toast1 = Toast.loading({
        duration: 5000, // 持续展示 toast
        forbidClick: true,
        message: '正在处理',
      })
      this.$axios.post('project/team3-sign', {
        id: item.id,
        act: params,
        val: checked ? 1 : 0
      }).then(data => {
        toast1.clear()
        item[params] = checked
        console.log(data, 'data')
      })
    },
    onBadge (item, item2, index) {
      if (this.job > 3) {
        this.$toast('无权操作')
        return
      }
      const toast1 = Toast.loading({
        duration: 5000, // 持续展示 toast
        forbidClick: true,
        message: '正在处理',
      })
      // this.loading = true
      this.$axios.post('project/team3-sign', {
        id: item.id,
        act: 'medal',
        level: item2.medal_level,
        val: item2.status
      }).then(res => {
        toast1.clear()
        console.log(res)
        if (res.data.code == 200) {
          item2.status = res.data.val ? 1 : 0
          // this.loading = false
          return
        }


      })
    },
    back () {
      this.$router.push({
        path: '/camper',
        query: {
          team3_id: this.team3_id,
        },
      })
    },

    getLongitudeLatitude () {
      // locations()
      // this.$wx.ready(function () {
      //   this.$wx.getLocation({//获取位置信息方法一定要放在wx.ready中调用
      //     type: 'gcj02', // 默认为wgs84的 gps 坐标，如果要返回直接给 openLocation 用的火星坐标，可传入'gcj02'；调试过程中发现wgs84获取的位置会偏移几百米左右
      //     isHighAccuracy: true,
      //     success: function (res) {
      //       var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
      //       var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
      //       var speed = res.speed; // 速度，以米/每秒计
      //       var accuracy = res.accuracy; // 位置精度
      //       console.log(res)
      //     },
      //     fail: function (res) {
      //       console.log('error:', res)
      //     },
      //   });
      // })
      // //如果该对象存在，那么地理位置服务可用。
      // if ('geolocation' in navigator) {
      //   /* 地理位置服务可用 */
      //   var options = {
      //     enableHighAccuracy: true, //布尔值，表示系统是否使用最高精度来表示结果，注意，这会导致较慢的响应时间或者增加电量消耗（比如对于支持gps的移动设备来说）。如果值为false ，设备会通过更快响应以及/或者使用更少的电量等方法来尽可能的节约资源。默认值fasle
      //     timeout: 5000, //它表明的是设备必须在多长时间（单位毫秒）内返回一个位置。默认直到获取到位置才会返回值。
      //     maximumAge: 0 //表明可以返回多长时间（即最长年龄，单位毫秒）内的可获取的缓存位置。如果设置为 0, 说明设备不能使用一个缓存位置，而且必须去获取一个真实的当前位置。默认0
      //   }
      //   function success (position) {
      //     //position.coords (只读) 返回一个定义了当前位置的Coordinates对象。
      //     //position.timestamp (只读) 返回一个时间戳DOMTimeStamp， 这个时间戳表示获取到的位置的时间。
      //     var lat = position.coords.latitude //当前位置的纬度
      //     var lng = position.coords.longitude //当前位置精度
      //   }
      //   function error (err) {
      //     var errorType = ['您拒绝共享位置信息', '获取不到位置信息', '获取位置信息超时']
      //     console.log(errorType[err.code - 1])
      //   }

      //   navigator.geolocation.getCurrentPosition(success, error, options)
      // } else {
      //   /* 地理位置服务不可用 */
      //   console.log('无法获取您的位置，请检查定位是否开启或刷新重试')
      // }
    }
  },
}
</script>
<style lang="scss" scoped>
.acmper {
  padding: 30px 10px;
  height: 100vh;
}

.gundong {
  border-bottom: 1px solid #f7f7f7;
  max-width: 100%;
  margin: auto;
  overflow-x: auto;
  white-space: nowrap;
  overflow-y: hidden;
}

.buttons {
  color: #fff;
  padding: 10px 30px;
  border: none;
  border-radius: 6px;
}

.text-center {
  text-align: center;
  font-weight: 700;
  padding: 5px 0;
}

.text-left {
  font-weight: 700;
  padding: 5px 0;
}

.red-color {
  background-color: red !important;
}

.huizhang {
  color: #fff;
  margin-right: 5px;
  background: #999;
  padding: 3px 4px;
  border-radius: 5px;
}

.gold {
  background: #1989fa;

}

.jinzhi {
  pointer-events: none;
}
</style>